import styled from 'styled-components';

import IconBackChevronSvg from '../../../assets/icons/icon-back-chevron.svg?react';
import { BaseButton } from '../../../shared/ui';

type ValueIntroBackButtonProps = {
  ariaLabel: string;
  onPress: () => void;
};

const BackButton = styled(BaseButton).attrs({
  'data-ui': 'registration-goals-value-intro-back-button',
})`
  width: ${({ theme }) => theme.scale.px(24)};
  height: ${({ theme }) => theme.scale.px(20)};
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const BackIcon = styled(IconBackChevronSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: ${({ theme }) => theme.scale.px(12)};
  height: ${({ theme }) => theme.scale.px(20)};
  display: block;
  color: ${({ theme }) => theme.colors.text.primary};

  & path {
    stroke: currentColor;
  }
`;

export function ValueIntroBackButton({
  ariaLabel,
  onPress,
}: ValueIntroBackButtonProps) {
  return (
    <BackButton aria-label={ariaLabel} type="button" onClick={onPress}>
      <BackIcon />
    </BackButton>
  );
}
